<div class="email-panel-container">
  <form #emailPanelForm="ngForm">

    <div class="cci-email-form-group">
      <h3>Email</h3>
    </div>

    <div class="cci-email-form-group">
      <div>
        Recipients:
        <input class="cci-email-input" type="text" name="recipients" [(ngModel)]="recipients" #recipientsValidation="ngModel" placeholder="example@racap.com,..." required>
        <span *ngIf="recipientsValidation.errors && showErrors" class="error">
          <span [hidden]="!recipientsValidation.errors.required">Required</span>
        </span>
      </div>

      <div>
        Subject (optional):
        <input class="cci-email-subject-input" type="text" name="emailSubject" [(ngModel)]="emailSubject" #emailSubjectValidation="ngModel" placeholder="My report...">
      </div>
    </div>

    <div class="cci-email-form-group">
      <button (click)="showErrors = true; emailPanelForm.valid && email()">Send email</button>
    </div>

  </form>
</div>
